export default "__VITE_ASSET__CUZVcSHE__"